var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stats-view',{staticClass:"h-100"})
}
var staticRenderFns = []

export { render, staticRenderFns }